import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'styles/global.css';
import App from './App';
import AppContextProvider from './context/AppContextProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import './i18n';
import "leaflet/dist/leaflet.css";

const container = document.getElementById('app');

const root = createRoot(container);
export const queryClient = new QueryClient();

root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </QueryClientProvider>
  </BrowserRouter>,
);
